import { detectEnvironment } from "@zektec/environment-utils";

// project config
const PROJECT_NAME = "Version2";

// firestore
const FIRESTORE_USERS_COLLECTIONS = "users";
const FIRESTORE_NOTIFICATIONS_COLLECTIONS = "notifications";
const FIRESTORE_USER_SUBSCRIPTIONS_COLLECTIONS_OLD = "subscriptions";
const FIRESTORE_USER_SUBSCRIPTIONS_COLLECTIONS = "user_subscriptions";
const FIRESTORE_USER_TRANSACTIONS_COLLECTIONS = "user_transactions";
const FIRESTORE_USER_ADJUSTMENTS_COLLECTIONS = "user_adjustments";
const FIRESTORE_USER_PAYMENTS_COLLECTIONS = "payments";
const FIRESTORE_USER_ADD_ONS_COLLECTIONS = "user_add_ons";
const FIRESTORE_USER_USER_ADD_ONS_COLLECTIONS = "user_add_ons";
const FIRESTORE_USER_USER_INTEGRATIONS_COLLECTIONS = "user_integrations";
const FIRESTORE_USER_PROCESSES_COLLECTIONS = "user_processes";

const ENVIRONMENT = detectEnvironment({
  origin: window.location.origin,
  mode: import.meta.env.MODE,
  productionHostIndicators: ["version2.io"],
  stagingIndicators: ["version2.pages.dev", "release-stage"],
  localHostIndicators: ["localhost", "website.v2.local", "admin.v2.local"],
});

const general = {
  PROJECT_NAME,
  ENVIRONMENT,
  FIRESTORE_USERS_COLLECTIONS,
  FIRESTORE_NOTIFICATIONS_COLLECTIONS,
  FIRESTORE_USER_SUBSCRIPTIONS_COLLECTIONS,
  FIRESTORE_USER_SUBSCRIPTIONS_COLLECTIONS_OLD,
  FIRESTORE_USER_TRANSACTIONS_COLLECTIONS,
  FIRESTORE_USER_ADJUSTMENTS_COLLECTIONS,
  FIRESTORE_USER_PAYMENTS_COLLECTIONS,
  FIRESTORE_USER_ADD_ONS_COLLECTIONS,
  FIRESTORE_USER_USER_ADD_ONS_COLLECTIONS,
  FIRESTORE_USER_USER_INTEGRATIONS_COLLECTIONS,
  FIRESTORE_USER_PROCESSES_COLLECTIONS,
};

export default general;
